/* ============================================================
   THE PATRIOT CODE — theme.js
   Vanilla port of the prototype's React interactions.
   Safe to run once on DOMContentLoaded; all features are
   feature-detected so missing sections never throw.
   ============================================================ */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- loader + hero entrance ---------- */
  function bootLoader() {
    var loader = document.querySelector("[data-loader]");
    var hero = document.querySelector(".hero");
    var done = function () {
      if (loader) loader.classList.add("done");
      if (hero) hero.classList.add("ready");
      document.documentElement.classList.add("loaded");
    };
    // reveal quickly; don't trap the page if assets are slow
    var delay = prefersReduced ? 0 : 250;
    setTimeout(done, delay);
    window.addEventListener("load", function () { setTimeout(done, 100); });
  }

  /* ---------- announcement bar: rotate messages ---------- */
  function bootPromo() {
    document.querySelectorAll("[data-promo]").forEach(function (wrap) {
      var msgs = wrap.querySelectorAll(".promo-msg");
      if (msgs.length < 2) { if (msgs[0]) msgs[0].classList.add("show"); return; }
      var i = 0;
      msgs[0].classList.add("show");
      setInterval(function () {
        msgs[i].classList.remove("show");
        i = (i + 1) % msgs.length;
        msgs[i].classList.add("show");
      }, 3600);
    });
  }

  /* ---------- header: frost on scroll ---------- */
  function bootHeader() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 24); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    // mega menu (hover on desktop, click/tap everywhere so it also works on tablets)
    var shopTrigger = header.querySelector("[data-mega-trigger]");
    var mega = header.querySelector("[data-mega]");
    if (shopTrigger && mega) {
      var open = function () { mega.classList.add("open"); shopTrigger.setAttribute("aria-expanded", "true"); };
      var close = function () { mega.classList.remove("open"); shopTrigger.setAttribute("aria-expanded", "false"); };
      shopTrigger.addEventListener("mouseenter", open);
      header.querySelectorAll(".nav a:not([data-mega-trigger])").forEach(function (a) {
        a.addEventListener("mouseenter", close);
      });
      mega.addEventListener("mouseenter", open);
      header.addEventListener("mouseleave", close);

      shopTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        if (mega.classList.contains("open")) { close(); } else { open(); }
      });
      document.addEventListener("click", function (e) {
        if (mega.classList.contains("open") && !header.contains(e.target)) close();
      });
      document.addEventListener("keydown", function (e) {
        if ((e.key === "Escape" || e.keyCode === 27) && mega.classList.contains("open")) close();
      });
    }

    // mobile drawer
    var drawer = document.querySelector("[data-drawer]");
    var burger = header.querySelector("[data-drawer-open]");
    if (drawer && burger) {
      var openD = function () { drawer.classList.add("open"); document.body.style.overflow = "hidden"; };
      var closeD = function () { drawer.classList.remove("open"); document.body.style.overflow = ""; };
      burger.addEventListener("click", openD);
      drawer.querySelectorAll("[data-drawer-close], a").forEach(function (el) {
        el.addEventListener("click", closeD);
      });
    }
  }

  /* ---------- reveal on scroll ---------- */
  function bootReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    if (prefersReduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -5% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- count-up stats ---------- */
  function bootCounters() {
    var nums = document.querySelectorAll("[data-count]");
    if (!nums.length) return;
    var run = function (el) {
      var to = parseFloat(el.getAttribute("data-count")) || 0;
      var suffix = el.getAttribute("data-suffix") || "";
      var dur = 1700, t0 = performance.now();
      if (prefersReduced) { el.textContent = to.toLocaleString() + suffix; return; }
      var tick = function (t) {
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.floor(e * to).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(tick); else el.textContent = to.toLocaleString() + suffix;
      };
      requestAnimationFrame(tick);
    };
    if (!("IntersectionObserver" in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---------- magnetic CTAs (desktop pointer only) ---------- */
  function bootMagnetic() {
    if (prefersReduced) return;
    document.querySelectorAll("[data-magnetic]").forEach(function (el) {
      el.addEventListener("mousemove", function (ev) {
        if (window.innerWidth < 860) return;
        var r = el.getBoundingClientRect();
        var x = ev.clientX - r.left - r.width / 2;
        var y = ev.clientY - r.top - r.height / 2;
        el.style.transform = "translate(" + x * 0.25 + "px," + y * 0.35 + "px)";
      });
      el.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  /* ---------- quantity stepper (cart + product) ---------- */
  function bootQtyStepper() {
    document.querySelectorAll("[data-qty-stepper]").forEach(function (wrap) {
      var input = wrap.querySelector("[data-qty-input]");
      var dec = wrap.querySelector("[data-qty-decrease]");
      var inc = wrap.querySelector("[data-qty-increase]");
      if (!input || !dec || !inc) return;
      var min = parseInt(input.getAttribute("min"), 10);
      if (isNaN(min)) min = 0;
      var step = function (delta) {
        var val = parseInt(input.value, 10);
        if (isNaN(val)) val = min;
        val = Math.max(min, val + delta);
        input.value = val;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      };
      dec.addEventListener("click", function () { step(-1); });
      inc.addEventListener("click", function () { step(1); });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function bootFaq() {
    document.querySelectorAll("[data-faq]").forEach(function (faq) {
      var items = faq.querySelectorAll(".faq-item");
      items.forEach(function (item) {
        var btn = item.querySelector(".faq-q");
        if (!btn) return;
        btn.addEventListener("click", function () {
          var isOpen = item.classList.contains("open");
          items.forEach(function (i) { i.classList.remove("open"); var b = i.querySelector(".faq-q"); if (b) b.setAttribute("aria-expanded", "false"); });
          if (!isOpen) { item.classList.add("open"); btn.setAttribute("aria-expanded", "true"); }
        });
      });
    });
  }

  /* ---------- campaign video: tap to play with sound ---------- */
  function bootCampaignVideo() {
    document.querySelectorAll("[data-campaign]").forEach(function (section) {
      var v = section.querySelector("video");
      var btn = section.querySelector("[data-campaign-toggle]");
      var hint = section.querySelector(".video-hint");
      if (!v) return;
      v.muted = true;
      if (!prefersReduced) {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if (!btn) return;
      var on = false;
      btn.addEventListener("click", function () {
        on = !on;
        v.muted = !on;
        if (on) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
        btn.classList.toggle("is-on", on);
        if (hint) hint.textContent = on ? "Sound on — tap to mute" : "Tap to play with sound";
      });
    });
  }

  /* ---------- "Notify me" email popup ----------
     Submits Shopify's native customer form (emails -> Admin > Customers).
     Because the page reloads on submit, we use a localStorage flag so the
     modal — and only the modal, not the footer newsletter — reopens with the
     success/error result. Storing the email works even without JS; JS only
     enhances the open/close + confirmation. */
  function bootNotify() {
    var modal = document.querySelector("[data-notify-modal]");
    if (!modal) return;
    var formView = modal.querySelector("[data-notify-form]");
    var successView = modal.querySelector("[data-notify-success]");
    var errorEl = modal.querySelector("[data-notify-error]");
    var form = modal.querySelector("form");
    var lastFocus = null;
    var FLAG = "tpcNotify";

    function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

    function open(asSuccess) {
      lastFocus = document.activeElement;
      if (formView) formView.hidden = asSuccess;
      if (successView) successView.hidden = !asSuccess;
      modal.classList.add("open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (!asSuccess && form) {
        var input = form.querySelector("input[type=email]");
        if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 80);
      }
    }
    function close() {
      modal.classList.remove("open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }

    document.querySelectorAll("[data-notify]").forEach(function (t) {
      t.addEventListener("click", function (e) { e.preventDefault(); if (errorEl) errorEl.hidden = true; open(false); });
    });
    modal.querySelectorAll("[data-notify-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if ((e.key === "Escape" || e.keyCode === 27) && modal.classList.contains("open")) close();
    });

    if (form) {
      form.addEventListener("submit", function () { lsSet(FLAG, "pending"); });
    }

    // resolve the outcome after the post-submit reload
    if (lsGet(FLAG) === "pending") {
      lsDel(FLAG);
      if (/[?&]customer_posted=true/.test(window.location.search)) {
        open(true);
      } else {
        if (errorEl) errorEl.hidden = false;
        open(false);
      }
    }
  }

  /* ---------- hero background video ---------- */
  function bootHeroVideo() {
    document.querySelectorAll(".hero-video, video.hero-media").forEach(function (v) {
      v.muted = true; v.loop = true;
      if (prefersReduced) { v.pause(); return; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function init() {
    bootLoader();
    bootPromo();
    bootHeader();
    bootReveal();
    bootCounters();
    bootMagnetic();
    bootFaq();
    bootCampaignVideo();
    bootHeroVideo();
    bootNotify();
    bootQtyStepper();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Shopify theme editor: re-init when sections are reloaded */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      bootPromo(); bootHeader(); bootReveal(); bootCounters(); bootMagnetic(); bootFaq(); bootCampaignVideo(); bootHeroVideo(); bootNotify(); bootQtyStepper();
    });
  }
})();
